$(document).ready(function(){
  $(document).on('click','[filter-variable-pass]',function(e){
      var filterDataValue = $(this).children('input').val();
      const queryString = window.location.search;
     const urlParams = new URLSearchParams(queryString);
    const product = urlParams.get('sort_by');
   var filterDataURL = window.history.replaceState(null, null, "?filter.v.price.gte=&filter.v.price.lte=&sort_by="+filterDataValue);
    var pageURL = $(location).attr("href");
   console.log("filter-variable-pass clicked");
    $.ajax({
      url: pageURL,
      type: 'GET',
      dataType: 'HTML',
      success: function(filter_data){        
        setTimeout(function(){              
        var filterHeading = $(filter_data).find('#main-collection-filters').html();
        $('#main-collection-filters').html(filterHeading);

        var filterContent = $(filter_data).find('#CollectionProductGrid').html();
        $('#CollectionProductGrid').html(filterContent)
          $("body").removeClass("overflow-hidden-mobile");
          $('.sw-right-side-mnu-jtpl').removeClass('hidden');

          $(".sortByMobileOptions-jtpl .radio-label").find("input[value='"+filterDataValue+"']").parents(".radio-label").addClass("active_sortby_jtpl");
           $("body").removeClass("overflow-cstm-filter");
        },100)  
        setTimeout(function(){ 
          let productonpage = $("#main-collection-product-grid");
       let nexturl = productonpage.attr("data-next-url");
       let loadmorebutton = $("#view-more-product");
       if (!nexturl) {
           loadmorebutton.hide();
       }

       $(document).on('click', '#view-more-product', function() {
           // event.preventDefault();

           // Check if nexturl is not empty or undefined before making the AJAX request
           if (nexturl === '' || nexturl === undefined) {
               loadmorebutton.hide();
               return; // Stop the function if no next URL is available
           }

           $.ajax({
               url: nexturl,
               type: "GET",
               dataType: "html",
               success: function(nextPage) {
                   let newProducts = $(nextPage).find("#main-collection-product-grid");
                   productonpage.append(newProducts.html());
                   let newurl = newProducts.attr("data-next-url");
                   nexturl = newurl;
                   // Reapply Mouseover functionality to new products
                   MouseoverSwipernew();
                   // Reinitialize Flickity for new content
                   initializeFlickity();
                   // If no more products are available (nexturl is empty), hide the button
                   if (nexturl === '' || nexturl === undefined) {
                       loadmorebutton.hide();
                   }
               }
           });
       });
        },3000);
      },
      error: function(){
        console.log("fail")
      }
    })
    $(this).addClass('active');
  });
});